import { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const menus = [
  { name: "Home", href: "#hero" },
  { name: "Features", href: "#features" },
  { name: "Journey", href: "#journey" },
  { name: "Testimonials", href: "#testimonials" },
  { name: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-slate-950/70 border-b border-white/10"
          : ""
      }`}
    >
      <div className="container mx-auto px-6 h-20 flex justify-between items-center">

        <a href="#hero" className="text-2xl font-black text-white">
          AI<span className="text-cyan-400">Learning</span>
        </a>

        <nav className="hidden lg:flex gap-10">

          {menus.map((menu) => (
            <a
              key={menu.name}
              href={menu.href}
              className="text-slate-300 hover:text-cyan-400 transition"
            >
              {menu.name}
            </a>
          ))}

        </nav>

        <button className="hidden lg:flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-slate-950 px-5 py-3 rounded-xl font-semibold">

          Get Started

          <ArrowRight size={18} />

        </button>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
        >
          {open ? <X /> : <Menu />}
        </button>

      </div>

      <AnimatePresence>

        {open && (

          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            className="overflow-hidden lg:hidden bg-slate-900 border-t border-white/10"
          >

            {menus.map((menu) => (
              <a
                key={menu.name}
                href={menu.href}
                className="block px-6 py-4 text-slate-300 hover:bg-slate-800"
              >
                {menu.name}
              </a>
            ))}

          </motion.div>

        )}

      </AnimatePresence>

    </header>
  );
}